export default {"src":"/_next/static/media/facebook_icon.3e0acbf0.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};